import { Controller } from '@hotwired/stimulus';
import fetchTurboFrame from '../utils';

export default class extends Controller {
  static targets = ['form', 'artworkRows', 'inputHeading', 'colorCount'];

  addRow() {
    const tbody = this.artworkRowsTarget;
    const allRows = tbody.querySelectorAll('tr');
    // Get the second-to-last row (last artwork row, before the total row)
    const lastRow = allRows.length > 1 ? allRows[allRows.length - 2] : null;

    if (lastRow) {
      const newRow = lastRow.cloneNode(true);
      // New row index (excluding total row)
      const newIndex = allRows.length - 1;

      // Clear all input values and update ids in the new row
      newRow.querySelectorAll('input, select').forEach((input) => {
        if (input.id) {
          input.id = input.id.replace(/_\d+_/, `_${newIndex}_`);
        }
        if (input.tagName === 'SELECT') {
          input.selectedIndex = 0;
        } else {
          input.value = '';
        }
      });

      // Set $0.00 placeholder for price cells
      const priceCells = newRow.querySelectorAll('.fs-3');
      priceCells.forEach((cell) => {
        cell.textContent = '$0.00';
      });

      // Insert before the total row (last row)
      const totalRow = tbody.querySelector('tr:last-child');
      tbody.insertBefore(newRow, totalRow);
    }
  }

  updateDiscipline() {
    const adminNamespace = this.formTarget.action.includes('/admin/')
      ? '/admin'
      : '';
    fetchTurboFrame(`${adminNamespace}/quotes/new?${this.quoteParams()}`);
  }

  quoteParams() {
    const params = new URLSearchParams();

    const customer = this.formTarget.querySelector(
      'select[name="quote[customer_id]"]'
    );
    if (customer) {
      params.append('quote[customer_id]', customer.value);
    }
    params.append(
      'quote[discipline]',
      this.formTarget.querySelector('input[name="quote[discipline]"]:checked')
        .value
    );
    this.formTarget
      .querySelectorAll(
        'input[name="quote[artworks_attributes][][garment_count]'
      )
      .forEach((input) => {
        params.append(
          'quote[artworks_attributes][][garment_count]',
          input.value
        );
      });
    this.formTarget
      .querySelectorAll('input[name="quote[option_price_ids][]"]')
      .forEach((input) => {
        params.append('quote[option_price_ids][]', input.value);
      });

    return params;
  }
}
